import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    personFirstName?: string;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetPersonFirstNameValue extends React.PureComponent<Props> {
    render(): string | null {
        const { personFirstName } = this.props;
        if (!personFirstName) {
            return null;
        }
        return personFirstName;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    personFirstName: makeSelectTimesheetValue('personFirstName')
});

export default connect(mapStateToProps)(TimesheetPersonFirstNameValue);
